/**
 * @generated SignedSource<<c4590abb54467fb56c7fae78c3499651>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "DuplicateOfferResult",
    "kind": "LinkedField",
    "name": "finishedDuplicateOfferSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sequence",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "step",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "widgets",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rawDocuments",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tags",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "globalVariables",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "folders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "frames",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FinishedDuplicateOfferSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FinishedDuplicateOfferSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "605d52fca338ae900c214645fc83ce3d",
    "id": null,
    "metadata": {},
    "name": "FinishedDuplicateOfferSubscription",
    "operationKind": "subscription",
    "text": "subscription FinishedDuplicateOfferSubscription(\n  $filter: BaseSubscriptionInput!\n) {\n  finishedDuplicateOfferSubscription(filter: $filter) {\n    sequence\n    id\n    step\n    widgets\n    documents\n    rawDocuments\n    tags\n    globalVariables\n    folders\n    frames\n  }\n}\n"
  }
};
})();

node.hash = "1387fe35b576c48245c59a207f1e23d4";

export default node;
